import * as i0 from '@angular/core';
import { Pipe, Injectable } from '@angular/core';
import * as i1 from '@angular/platform-browser';
import * as i1$1 from '@ngx-translate/core';

class DoctorSpecialityPipe {
    transform(specialityList) {
        if (specialityList && !Array.isArray(specialityList)) {
            throw new TypeError('`doctorSpeciality` pipe expects array as an input!');
        }
        const specialityNames = [];
        if (specialityList) {
            specialityList.map((speciality) => {
                specialityNames.push(speciality.name);
            });
        }
        return specialityNames.join(', ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorSpecialityPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: DoctorSpecialityPipe, isStandalone: true, name: "doctorSpeciality" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorSpecialityPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'doctorSpeciality', standalone: true }]
        }] });

class DoctorFullNamePipe {
    transform(doctor) {
        return this.constructDoctorFullName(doctor);
    }
    constructDoctorFullName(doctor) {
        let fullName = '';
        if (!doctor) {
            return fullName;
        }
        if (doctor.pre_salutation &&
            doctor.pre_salutation.trim() &&
            doctor.pre_salutation.trim() !== '-') {
            fullName += `${doctor.pre_salutation.trim()}`;
        }
        if (doctor.first_name && doctor.first_name.trim()) {
            fullName += ` ${doctor.first_name.trim()}`;
            fullName = fullName.trim();
        }
        if (doctor.last_name && doctor.last_name.trim()) {
            fullName += ` ${doctor.last_name.trim()} `;
            fullName = fullName.trim();
        }
        if (doctor.post_salutation &&
            doctor.post_salutation.trim() &&
            doctor.post_salutation.trim() !== '-') {
            fullName += ` ${doctor.post_salutation.trim()}`;
        }
        return fullName;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorFullNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: DoctorFullNamePipe, isStandalone: true, name: "doctorFullName" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorFullNamePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'doctorFullName', standalone: true }]
        }] });

class DoctorExperiencePipe {
    transform(experienceList) {
        if (experienceList && !Array.isArray(experienceList)) {
            throw new TypeError('`doctorExperience` pipe expects array as an input!');
        }
        let years = 0;
        if (experienceList?.length) {
            const sorted = experienceList.sort(function (a, b) {
                return a.start_year.localeCompare(b.start_year);
            });
            const currentDate = new Date(), startYear = Number(sorted[sorted.length - 1].start_year), startMonth = Number(sorted[sorted.length - 1].start_month);
            if (!startYear && !startMonth)
                return 0;
            if (startYear)
                currentDate.setFullYear(startYear);
            if (startMonth)
                currentDate.setMonth(startMonth);
            years = this.getDateDifference(currentDate).years;
        }
        if (years) {
            return Number(parseFloat(years.toString()).toFixed(0));
        }
        else {
            return 0;
        }
    }
    getDateDifference(createdDate) {
        // TODO: Move this to utility
        const date = new Date(createdDate);
        const currentDate = new Date();
        const dateDiff = {
            miliseconds: null,
            seconds: null,
            minutes: null,
            hours: null,
            days: null,
            months: null,
            years: null,
        };
        dateDiff.miliseconds = currentDate - date;
        dateDiff.seconds = dateDiff.miliseconds / 1000;
        dateDiff.minutes = dateDiff.seconds / 60;
        dateDiff.hours = dateDiff.minutes / 60;
        dateDiff.days = dateDiff.hours / 24;
        dateDiff.months = dateDiff.days / 30;
        dateDiff.years = dateDiff.months / 12;
        return dateDiff;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorExperiencePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: DoctorExperiencePipe, isStandalone: true, name: "doctorExperience" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorExperiencePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'doctorExperience', standalone: true }]
        }] });

class SafeUrlPipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: SafeUrlPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: SafeUrlPipe, isStandalone: true, name: "safeUrl" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: SafeUrlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeUrl',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }] });

class AttrValueByLanguagePipe {
    transform(value, language, key = 'name') {
        if (!value) {
            return;
        }
        const result = value.filter((category) => {
            return category.language === language && category.attribute_key === key;
        });
        if (result && result.length > 0)
            return result[0].attribute_value !== undefined
                ? result[0].attribute_value
                : '';
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: AttrValueByLanguagePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: AttrValueByLanguagePipe, isStandalone: true, name: "attrValueByLanguage" }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: AttrValueByLanguagePipe }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: AttrValueByLanguagePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'attrValueByLanguage',
                    standalone: true,
                }]
        }, {
            type: Injectable
        }] });

var FileFormats;
(function (FileFormats) {
    FileFormats["webp"] = "webp";
    FileFormats["jpeg"] = "jpeg";
    FileFormats["jpg"] = "jpg";
    FileFormats["png"] = "png";
})(FileFormats || (FileFormats = {}));

class ImageByTypePipe {
    transform(images, format = '', fallbackImageUrl = '') {
        if (!images || !images.length) {
            return fallbackImageUrl;
        }
        if (format) {
            const formattedImgResult = images.filter((image) => image.extension === format);
            return this.getUrlFromFilteredImages(formattedImgResult);
        }
        const fallbackImgResult = images.filter((image) => image.extension !== FileFormats.webp);
        return this.getUrlFromFilteredImages(fallbackImgResult) || fallbackImageUrl;
    }
    getUrlFromFilteredImages(images) {
        return (images[0] && images[0].url) || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: ImageByTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: ImageByTypePipe, isStandalone: true, name: "imageByType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: ImageByTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'imageByType',
                    standalone: true,
                }]
        }] });

class DateTimePipe {
    transform(epochTime, timeZone = 'Asia/Jakarta', options = {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
    }, locale = 'id') {
        if (!epochTime || !timeZone)
            return '';
        options.timeZone = timeZone;
        const _dateFormatter = Intl.DateTimeFormat(locale, options);
        return _dateFormatter.format(epochTime);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DateTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: DateTimePipe, isStandalone: true, name: "dateTime" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DateTimePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'dateTime', standalone: true }]
        }] });

class AddDashPipe {
    transform(originalWord) {
        return originalWord.replace(/ /g, '-');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: AddDashPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: AddDashPipe, isStandalone: true, name: "addDash" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: AddDashPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'addDash', standalone: true }]
        }] });

class DashToTitlePipe {
    transform(originalWord) {
        if (!originalWord)
            return '';
        return originalWord
            .replace(/-/g, ' ')
            .replace(/_/g, ' ')
            .replace(/\b[a-z]/g, this.toTitleCase);
    }
    toTitleCase(match, offset, other) {
        return match.toUpperCase();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DashToTitlePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: DashToTitlePipe, isStandalone: true, name: "dashToTitleCase" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DashToTitlePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'dashToTitleCase', standalone: true }]
        }] });

class DisplayNamePipe {
    transform(values, language) {
        if (values && values.length > 0) {
            const result = values.filter((attribute) => attribute.value.language === language);
            if (result && result.length > 0)
                return result[0].value.data;
            return null;
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DisplayNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: DisplayNamePipe, isStandalone: true, name: "displayName" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DisplayNamePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'displayName', standalone: true }]
        }] });

class SafeHtml {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: SafeHtml, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: SafeHtml, isStandalone: true, name: "safeHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: SafeHtml, decorators: [{
            type: Pipe,
            args: [{ name: 'safeHtml', standalone: true }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }] });

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 */
class FileSizePipe {
    constructor() {
        this.units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    }
    transform(bytes = 0, precision = 0) {
        if (isNaN(parseFloat(String(bytes))) || !isFinite(bytes))
            return '?';
        let unit = 0;
        while (bytes >= 1024) {
            bytes /= 1024;
            unit++;
        }
        return bytes.toFixed(+precision) + ' ' + this.units[unit];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: FileSizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: FileSizePipe, isStandalone: true, name: "fileSize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: FileSizePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'fileSize', standalone: true }]
        }] });

class MaskKeywordPipe {
    transform(keyword, start = 0, end = 0, maskChar = '*') {
        if (!keyword)
            return '';
        if (keyword.length && keyword.length >= start + end) {
            const mask = keyword.substring(start, keyword.length - end);
            const maskedPart = mask.replace(/./g, maskChar);
            const maskedText = keyword.replace(mask, maskedPart);
            return maskedText;
        }
        else
            return keyword;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: MaskKeywordPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: MaskKeywordPipe, isStandalone: true, name: "maskKeyword" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: MaskKeywordPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'maskKeyword', standalone: true }]
        }] });

class FormatTimePipe {
    transform(value) {
        //MM:SS format
        const minutes = Math.floor(value / 60);
        return (('00' + minutes).slice(-2) +
            ':' +
            ('00' + Math.floor(value - minutes * 60)).slice(-2));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: FormatTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: FormatTimePipe, isStandalone: true, name: "formatTime" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: FormatTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'formatTime',
                    standalone: true,
                }]
        }] });

class DoctorLabelPipe {
    constructor(translate, doctorExperiencePipe) {
        this.translate = translate;
        this.doctorExperiencePipe = doctorExperiencePipe;
    }
    transform(doctor) {
        return this.getDoctorLabels(doctor);
    }
    getDoctorLabels(doctor) {
        if (!doctor) {
            return [];
        }
        const experience = `${this.doctorExperiencePipe.transform(doctor.doctor_profile_sections?.experience)} ${this.translate.instant('YEARS')}`;
        const rating = `${doctor.rating}%`;
        return [
            {
                webpImage: '/hd-assets/images/webp/hd-ic-luggage.webp',
                fallbackImage: '/hd-assets/images/png/hd-ic-luggage.png',
                text: experience,
            },
            {
                webpImage: '/hd-assets/images/webp/hd-ic-rating.webp',
                fallbackImage: '/hd-assets/images/png/hd-ic-rating.png',
                text: rating,
            },
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorLabelPipe, deps: [{ token: i1$1.TranslateService }, { token: DoctorExperiencePipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.1.6", ngImport: i0, type: DoctorLabelPipe, isStandalone: true, name: "doctorLabel" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.1.6", ngImport: i0, type: DoctorLabelPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'doctorLabel',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$1.TranslateService }, { type: DoctorExperiencePipe }] });

/*
 * Public API Surface of pipes
 */
/** Pipes */

/**
 * Generated bundle index. Do not edit.
 */

export { AddDashPipe, AttrValueByLanguagePipe, DashToTitlePipe, DateTimePipe, DisplayNamePipe, DoctorExperiencePipe, DoctorFullNamePipe, DoctorLabelPipe, DoctorSpecialityPipe, FileSizePipe, FormatTimePipe, ImageByTypePipe, MaskKeywordPipe, SafeHtml, SafeUrlPipe };
